import { t } from '@lingui/core/macro';

import type { StudyLanguage } from '@/api/core-api/types.gen';

import { Select } from '@/components/base/select/select';
import { STUDY_LANGUAGE_LABELS, STUDY_LANGUAGES } from '@common/utils';

function getStudyLanguageOptions(): Array<{
  id: StudyLanguage;
  label: string;
}> {
  return STUDY_LANGUAGES.map((code) => ({
    id: code,
    label: STUDY_LANGUAGE_LABELS[code],
  })).toSorted((a, b) => a.label.localeCompare(b.label));
}

interface StudyLanguageSelectProps {
  value: StudyLanguage;
  onChange: (language: StudyLanguage) => void;
  size?: 'xs' | 'sm' | 'md';
  label?: string;
}

/** Study-language picker shared by the creation funnel and the study-type drawer. */
export function StudyLanguageSelect({
  value,
  onChange,
  size,
  label = t`Interview language`,
}: StudyLanguageSelectProps) {
  return (
    <Select<StudyLanguage>
      size={size}
      label={label}
      value={value}
      onSelectionChange={onChange}
      items={getStudyLanguageOptions()}
      placeholder={t`Select a language`}
    >
      {(item) => <Select.Item {...item} />}
    </Select>
  );
}
